<template>
  <generic-modal :title="$t('start event')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input
            type="text"
            class="input"
            v-model="meta.name"
            :placeholder="$t('name')"
          />
        </div>
      </div>
    </form>
    <pre class="mt-5">{{ element }}</pre>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  api_host,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "StartEventModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      element: null,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(element) {
      let v = this;
      v.set_initial_state();
      if (element) {
        // console.log("element", element);
        v.element = element;
        if (element.settings) {
          v.meta = { ...element.settings };
        }
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.$emit("success", { id: v.element.id, settings: v.meta });
      v.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.element = null;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
